/* eslint-disable no-useless-escape */
/* eslint-disable no-redeclare */

import { removeHttpImageUrl } from "util/photo";
import { privacyOptOutInlineCheck } from "util/privacy";
const YOUTUBE = "youtube";
const YOUTUDOTBE = "youtu.be";
const VIMEO = "vimeo";

const capitalize = (str, lower = false) =>
  (lower ? str && str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) =>
    match.toUpperCase(),
  );

const overAlmostAbout = (data, langCode) => {
  const lang = langCode;
  const finalString =
    data && data.diffInbeforeAfterRound >= 0.8
      ? lang && lang.ldp_content && lang.ldp_content.recomm_about
      : 0.8 > data.diffInbeforeAfterRound && data.diffInbeforeAfterRound >= 0.3
      ? lang && lang.ldp_content && lang.ldp_content.recomm_over
      : lang && lang.ldp_content && lang.ldp_content.recomm_almost;
  return finalString;
};

const getCertDetails = (certificationDetails, selectedCertificate) => {
  let certDetails = [];

  const name = selectedCertificate && selectedCertificate.toLowerCase();

  let showCert = true;
  if (
    name === "lvnv" ||
    name === "bsma" ||
    name === "noct" ||
    name === "tafl" ||
    name === "pppa" ||
    name === "trc" ||
    name === "abrm" ||
    name === "relay"
  ) {
    showCert = false;
  }

  if (showCert) {
    certDetails =
      certificationDetails &&
      certificationDetails.filter(
        (certificate) =>
          certificate && certificate.certName && certificate.certName.toLowerCase() == name,
      );
  }

  return certDetails;
};

const checkValidVideoUrl = (url) => {
  let validUrlStatus;
  if (
    url.includes(YOUTUBE) ||
    url.includes(YOUTUDOTBE) ||
    url.includes(VIMEO) ||
    url.endsWith(".mp4")
  ) {
    validUrlStatus = true;
  } else {
    validUrlStatus = false;
  }
  return validUrlStatus;
};

const getVideoUrl = (url) => {
  let updateVedioUrl;
  if (url.includes(YOUTUBE) || url.includes(YOUTUDOTBE)) {
    const youtube_id_pattern = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??(v=)?([^#\&\?]*).*/;
    const matched_array = url && url.match(youtube_id_pattern);
    const video_id = matched_array && matched_array[8].length >= 11 ? matched_array[8] : "";
    updateVedioUrl = `https://youtube.com/embed/${video_id}?modestbranding=1&rel=0`;
  } else if (url.includes(VIMEO)) {
    const vimeo_id_arry = url && url.split("vimeo.com/video/");
    const vimeo_id = vimeo_id_arry && vimeo_id_arry[1];

    updateVedioUrl =
      vimeo_id && `https://player.vimeo.com/video/${vimeo_id}?autoplay=1&loop=1&autopause=0`;
  } else {
    updateVedioUrl = removeHttpImageUrl(url);
  }

  return updateVedioUrl;
};

const insertAString = (mainString, insertAfterString, text) => {
  let arr = mainString && mainString.split(insertAfterString);
  if (arr && arr.length > 0) {
    arr[1] = arr[1] + text;
    arr = arr && arr.join("/");
  }
  return arr;
};

const getExp = (dateString) => {
  var now = new Date();

  var yearNow = now.getYear();
  var monthNow = now.getMonth();
  var dateNow = now.getDate();

  var dob = new Date(
    dateString.substring(6, 10),
    dateString.substring(0, 2) - 1,
    dateString.substring(3, 5),
  );

  var yearDob = dob.getYear();
  var monthDob = dob.getMonth();
  var dateDob = dob.getDate();
  var age = {};
  // eslint-disable-next-line no-unused-vars
  var ageString = "";
  var yearString = "";
  var monthString = "";
  // eslint-disable-next-line no-unused-vars
  var dayString = "";

  let yearAge = yearNow - yearDob;

  if (monthNow >= monthDob) var monthAge = monthNow - monthDob;
  else {
    yearAge--;
    var monthAge = 12 + monthNow - monthDob;
  }

  if (dateNow >= dateDob) var dateAge = dateNow - dateDob;
  else {
    monthAge--;
    var dateAge = 31 + dateNow - dateDob;

    if (monthAge < 0) {
      monthAge = 11;
      yearAge--;
    }
  }

  age = {
    years: yearAge,
    months: monthAge,
    days: dateAge,
  };

  if (age.years > 1) yearString = " years";
  else yearString = " year";
  if (age.months > 1) monthString = " months";
  else monthString = " month";
  if (age.days > 1) dayString = " days";
  else dayString = " day";

  if (age.years > 0 && age.months > 0 && age.days > 0)
    ageString = age.years + yearString + " " + age.months + monthString;
  else if (age.years == 0 && age.months == 0 && age.days > 0) ageString = "Only " + +" ";
  else if (age.years > 0 && age.months == 0 && age.days == 0)
    ageString = age.years + yearString + " ";
  else if (age.years > 0 && age.months > 0 && age.days == 0)
    ageString = age.years + yearString + "  " + age.months + monthString + "";
  else if (age.years == 0 && age.months > 0 && age.days > 0)
    ageString = age.months + monthString + "  " + +"";
  else if (age.years > 0 && age.months == 0 && age.days > 0)
    ageString = age.years + yearString + "  " + +"";
  else if (age.years == 0 && age.months > 0 && age.days == 0)
    ageString = age.months + monthString + "";
  else ageString = "Oops! Could not calculate!";

  return age;
};

const getAgentExp = (agentData) => {
  let finalAgentExp;
  let yearOfExp = agentData && agentData.first_year > 0 ? agentData.first_year : "0000";
  let monthOfExp = agentData && agentData.first_month > 0 ? agentData.first_month : 0;
  let finalAgenYears = new Date().getFullYear() - parseInt(yearOfExp);

  if (monthOfExp > 0 && monthOfExp <= 9) {
    monthOfExp = `0${monthOfExp}`;
  }

  const date = `${monthOfExp}/01/${yearOfExp}`;
  // finalAgentExp = getAge(`${date}`);
  if (monthOfExp) {
    finalAgentExp = getExp(`${date}`);
  } else {
    finalAgentExp = { years: finalAgenYears };
  }

  return finalAgentExp;
};

// The Permutive loader is gated on the CCPA / Global Privacy Control opt-out signals: the
// SSR HTML can be cached, so the check is re-evaluated in the browser before anything loads.
const getPixelScript = (pageType) => `(function(){ if (${privacyOptOutInlineCheck}) { return; }
!function(n,e,i){if(!n){n = n || {}, window.permutive = n, n.q = [], n.config = i || {}, n.config.apiKey = e, n.config.environment = n.config.environment || "production";for(var o=["addon","identify","track","trigger","query","segment","segments","ready","on","once","user","consent"],r=0;r<o.length;r++){var t=o[r];n[t]=function(e){return function(){var i=Array.prototype.slice.call(arguments,0);n.q.push({functionName:e,arguments:i})}}(t)}}}(window.permutive,"2336e88c-2653-4e72-9d49-c562730fd85f",{ });
window.googletag=window.googletag||{ },window.googletag.cmd=window.googletag.cmd||[],window.googletag.cmd.push(function(){if(0===window.googletag.pubads().getTargeting("permutive").length){var g=window.localStorage.getItem("_pdfps");window.googletag.pubads().setTargeting("permutive",g?JSON.parse(g):[]);var o=window.localStorage.getItem("permutive-id");o&&(window.googletag.pubads().setTargeting("puid",o),window.googletag.pubads().setTargeting("ptime",Date.now().toString()))}});
(function(){ var gads = document.createElement('script');
gads.async = true; gads.type = 'text/javascript';
var useSSL = 'https:' == document.location.protocol;
gads.src = (useSSL ? 'https:' : 'http:') + '//0cf17917-395b-4f25-91cc-db3bdd6044b0.edge.permutive.app/5dc35e4e-c442-405b-bf5f-5c2b8824b0cf-web.js';
var node = document.getElementsByTagName('script')[0];
node.parentNode.insertBefore(gads, node);
})();
window.permutive.addon('web', {'page': {'realtor': {pageType: '${pageType}'}} });
})();`;

module.exports = {
  getVideoUrl,
  getCertDetails,
  capitalize,
  overAlmostAbout,
  checkValidVideoUrl,
  insertAString,
  getAgentExp,
  getPixelScript,
};
